import { ScribeCorrectionMode } from '../types';

const SCRIBE_CORRECTION_MODE_STORAGE_KEY = 'scribe_correction_mode';

export const getNormalizedScribeCorrectionMode = (
  fallback: ScribeCorrectionMode = ScribeCorrectionMode.Fast
): ScribeCorrectionMode => {
  const storedValue = window.localStorage.getItem(SCRIBE_CORRECTION_MODE_STORAGE_KEY);

  if (
    storedValue === ScribeCorrectionMode.Fast ||
    storedValue === ScribeCorrectionMode.Accurate ||
    storedValue === ScribeCorrectionMode.Unset
  ) {
    return storedValue;
  }

  window.localStorage.setItem(SCRIBE_CORRECTION_MODE_STORAGE_KEY, fallback);
  return fallback;
};
